import { jsx as _jsx } from "react/jsx-runtime";
import { faCircleEnvelope } from '@fortawesome/pro-thin-svg-icons';
import { useMultiStyleConfig } from '@companydotcom/potion';
import { FontAwesomeIcon } from '../font-awesome-icon';
export const CircleEnvelopeIcon = (props) => {
    const styles = useMultiStyleConfig('Icons', props);
    // @ts-ignore
    return _jsx(FontAwesomeIcon, { icon: faCircleEnvelope, sx: styles.circleEnvelope }, void 0);
};
